import {Navigate} from "react-router-dom";
import {useAuth} from "./AuthContext";

export default function RequireAuth({children,role}){

  const{user,loading}=useAuth();

  if(loading){
    return <div className="text-white p-6">Loading…</div>;
  }

  // not logged in → correct login
  if(!user.uid){
    if(role==="admin") return <Navigate to="/admin/login" replace />;
    if(role==="business") return <Navigate to="/business/login" replace />;
    if(role==="reseller") return <Navigate to="/reseller/login" replace />;
    return <Navigate to="/" replace />;
  }

  // ✅ TEMP: DO NOT BLOCK BY ROLE
  // role validation will be re-enabled after data is confirmed

  return children;
}
